<template>
  <div>
    <!-- <div class="button cta success small import">
      <i class="fa fa-upload"></i>{{ $t('consumer.creditCards.export') }}
    </div> -->
    <div class="clearfix"></div>

    <table v-if="!isMobile">
      <thead>
        <th>{{ $t('consumer.creditCards.addedOn') }}</th>
        <th>{{ $t('consumer.creditCards.creditCard') }}</th>
        <th>{{ $t('consumer.creditCards.address') }}</th>
        <th>{{ $t('consumer.creditCards.city') }}</th>
        <th>{{ $t('consumer.creditCards.state') }}</th>
        <th>{{ $t('consumer.creditCards.zip') }}</th>
        <th>{{ $t('consumer.creditCards.status') }}</th>
      </thead>
      <tbody>
        <tr v-for="card in creditCards" v-show="creditCards.length > 0">
          <td>{{ card.date }}</td>
          <td>{{ card.card }}</td>
          <td>{{ card.address }}</td>
          <td>{{ card.city }}</td>
          <td>{{ card.state }}</td>
          <td>{{ card.zip }}</td>
          <td v-bind:class="['status', cardStatus(card.status)]">{{ cardStatus(card.status) }}</td>
        </tr>

        <tr v-show="loading">
          <td colspan="7" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ $t('consumer.creditCards.loading') }}
          </td>
        </tr>

        <tr v-show="creditCards.length === 0 && !loading">
          <td colspan="7" class="table-block">
            {{ $t('consumer.creditCards.emptyState') }}
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div v-if="creditCards.length > 0">
        <div class="cards" v-for="(card, i) in creditCards" :key="i">
          <div class="card">
            <div class="title card-header">
              <div class="time">{{ card.date }}</div>
              <div :class="['status', cardStatus(card.status)]">{{ cardStatus(card.status) }}</div>
            </div>
            <div class="credit-card">
              <i class="fas fa-credit-card"></i> {{ card.card }}
            </div>
            <div class="title">
              <span class="label">Address:</span>
              <div class="value">{{ card.address ? card.address : '--' }}</div>
            </div>
            <div class="title">
              <span class="label">City:</span>
              <div class="value">{{ card.city ? card.city : '--' }}</div>
            </div>
            <div class="title">
              <span class="label">State:</span>
              <div class="value">{{ card.state ? card.state : '--' }}</div>
            </div>
            <div class="title">
              <span class="label">ZIP:</span>
              <div class="value">{{ card.zip ? card.zip : '--' }}</div>
            </div>
            
          </div>
        </div>
      </div>
      <div v-else>
        {{ $t('consumer.creditCards.emptyState') }}
      </div>
    </div>
  </div>
</template>

<script>
import ApiCards from '../../modules/api/consumer/credit-cards'

export default {
  name: 'creditCards',
  props: ['conId', 'isMobile'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    creditCards () {
      return this.$store.state.consumer.creditCards.list
    },
    isMax () {
      return this.$store.state.consumer.creditCards.isMax
    }
  },
  methods: {
    init () {
      this.$store.commit('consumer/resetCards')
      this.$store.commit('consumer/setCardsIsMax', false)
      this.$store.commit('consumer/setCardsCurrentPage', 0)

      this.getCards()
    },
    getCards () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiCards.getCards(self, self.conId, function () {
        self.loading = false
      })
    },
    cardStatus (isVerified) {
      return isVerified ? 'verified' : 'unverified'
    }
  },
  watch: {
    conId: function (value) {
      this.init()
    },
    isMobile: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.import{
  float: right;
  .fa{ margin-right: 5px; }
}

.clearfix{ clear: both; }

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

.status{
  text-transform: uppercase;
  font-weight: 600;

  &.verified{ color: #26D97A; }
  &.unverified{ color: #F20D0D; }
}

@media only screen and (max-width: 430px) {
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
          .time {
            font-size: 12px;
            color: #777;
            word-spacing: 5px;
          }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/CreditCards.vue